export const percent = (value: number | null | undefined): string =>
  value === null || value === undefined ? "-" : `${value}%`;

export const sumOfAmounts = (amounts: number[]): string =>
  String(amounts.reduce((sum, amount) => sum + Math.round(amount * 1000), 0) / 1000);
